import ActionDisabledTooltip from '@/components/buttons/ActionDisabledTooltip';
import { TransferBulk } from '@/components/buttons/TransferBulk/TransferBulk';
import { useTokenSelection } from '@/components/features/Account/AccountNFTList/useTokenSelection';
import { ReservoirAction } from '@/utils/reservoir';
import { Button, Flex } from '@chakra-ui/react';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  onRefresh(): void;
};

export const TokenSelectControls = ({ onRefresh }: Props) => {
  const { t } = useTranslation('account');
  const [isSelecting, selectedTokens, setSelecting] = useTokenSelection(state => [
    state.isSelecting,
    state.selectedTokens,
    state.setSelecting,
  ]);

  return isSelecting ? (
    <Flex gap={{ base: 'space.16', md: 'space.24' }} align="stretch" justify="stretch">
      <TransferBulk
        trigger={
          <ActionDisabledTooltip action={ReservoirAction.TransferBulk}>
            <Button isDisabled={!selectedTokens.length} flex="1">
              {t('assets.select.transfer', { count: selectedTokens.length })}
            </Button>
          </ActionDisabledTooltip>
        }
        onClose={isTransferred => isTransferred && onRefresh()}
      />
      <Button onClick={() => setSelecting(false)} variant="secondary" flex="1">
        {t('assets.select.cancel')}
      </Button>
    </Flex>
  ) : (
    <Button onClick={() => setSelecting(true)} variant="primary">
      {t('assets.select.label')}
    </Button>
  );
};
